import { useState, type JSX } from 'react'

import { DownloadCircledIcon } from '@icons/DownloadCircledIcon'
import { FileIcon } from '@icons/FileIcon'

import IconButton from '@global/iconButton/IconButton'

import { Dropdown } from '../Dropdown/Dropdown'
import { DropdownCard } from '../Dropdown/DropdownCard'
import { DropdownList } from '../Dropdown/DropdownList'
import { DropdownListItem } from '../Dropdown/DropdownListItem'

import styles from './DownloadDropdown.module.scss'

interface Props {
  onDownload: (fileType?: string) => void
}

export const DownloadDropdown = ({ onDownload }: Props): JSX.Element => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false)

  const handleDownload = (fileType: string) => {
    onDownload(fileType)
    setIsDropdownOpen(false)
  }

  const fileTypesToDownload = [
    { label: 'Excel', fileType: 'excel', icon: FileIcon },
    { label: 'PDF', fileType: 'pdf', icon: FileIcon },
    { label: 'CSV', fileType: 'csv', icon: FileIcon },
  ]

  return (
    <Dropdown
      direction='bottomLeft'
      distance='0.5rem'
      isOpen={isDropdownOpen}
      setIsOpen={setIsDropdownOpen}
      content={
        <DropdownCard>
          <DropdownList className={styles.dropdownList}>
            {fileTypesToDownload.map(({ label, fileType, icon }) => {
              return (
                <DropdownListItem
                  key={label}
                  onClick={() => handleDownload(fileType)}
                  startIcon={icon}
                  className={styles.dropdownListItem}
                >
                  {label}
                </DropdownListItem>
              )
            })}
          </DropdownList>
        </DropdownCard>
      }
    >
      <IconButton.New appearance='secondary' size='M' onClick={() => setIsDropdownOpen(true)}>
        <DownloadCircledIcon />
      </IconButton.New>
    </Dropdown>
  )
}
